/**
 * Modulo per la gestione della pagina Acquista
 * Gestisce la ricerca per codice lotto e il caricamento della scheda dettagliata
 */
import Page from "~/pages/Page";
import UI from "~/ui";
import $ from "jquery";
import { initializeInputMasks } from "~/input-mask";
import { Timeline } from "~/components/Timeline";

/**
 * Classe per la gestione della pagina Acquista
 */
class Acquista extends Page {

    constructor() {
        super("acquista", "Acquista");
    }

    /**
     * Inizializza la pagina
     */
    pageStart(): Promise<void> {
        initializeInputMasks();
        new Timeline().init();
        this.initEventHandlers();
        return Promise.resolve();
    }

    /**
     * Inizializza gli event handler della pagina
     */
    private initEventHandlers(): void {

        // Gestione del click sul pulsante di ricerca
        $("#btnCercaCodice").on("click", (e: JQuery.ClickEvent) => {
            e.preventDefault();
            this.handleSearchClick();
        });

        // Gestione dell'invio tramite tasto Enter
        $("#txtRicercaPerCodice").on("keypress", (e: JQuery.KeyPressEvent) => {
            if (e.which === 13) { // Enter key
                e.preventDefault();
                this.handleSearchClick();
            }
        });
    }

    /**
     * Gestisce il click sul pulsante di ricerca
     */
    private handleSearchClick(): void {
        const inputValue = $("#txtRicercaPerCodice").val() as string;
        const trimmedValue = inputValue?.trim() || "";

        if (!this.validateInput(trimmedValue)) {
            return;
        }

        this.loadSchedaDettagliataByCodice(trimmedValue);
    }

    /**
     * Valida l'input inserito dall'utente
     * @param value - Valore da validare
     * @returns true se valido, false altrimenti
     */
    private validateInput(value: string): boolean {
        if (!value) {
            bootbox.alert("Per favore, inserisci un codice per la ricerca.");
            return false;
        }

        const isNumeric = /^\d+$/.test(value);
        if (!isNumeric) {
            bootbox.alert("Inserire un codice numerico valido per la ricerca.");
            return false;
        }

        return true;
    }

    /**
     * Carica la scheda dettagliata associata a un codice lotto.
     * Effettua una chiamata AJAX asincrona e gestisce il risultato.
     *
     * @param codice - Il codice numerico del lotto da cercare.
     */
    private async loadSchedaDettagliataByCodice(codice: string): Promise<void> {
        // Avvia lo spinner
        this.spinner.spin();

        try {
            const url = `${window.BaseUrlWebApi}Search/GetSchedaByCodice?lottoId=${codice}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            // Verifica se la risposta HTTP è OK (200-299)
            if (!response.ok) {
                throw new Error(`Errore HTTP: ${response.status} - ${response.statusText}`);
            }

            // Parsa la risposta JSON
            const data: string = await response.json();

            // Verifica se la ricerca ha avuto successo
            if (data != undefined && data != "") {
                // Reindirizza all'URL della scheda
                window.location.href = data;
            } else {
                // Mostra il messaggio di errore dal server o un messaggio di default
                const message = "Il codice inserito non corrisponde a nessuna scheda in pubblicità.";
                UI.confirmOneButton("Attenzione", message);
            }

        } catch (error) {
            console.error('Errore nel recupero della URI della scheda dettagliata:', error);
            UI.confirmOneButton(
                "Errore", 
                "Si è verificato un errore durante il recupero della scheda. Per favore, riprova più tardi."
            );
        } finally {
            // Ferma lo spinner
            this.spinner.stop();
        }
    }


}

export default Acquista;
